export default __webpack_public_path__ + "assets/images/Payment_03.c25759.avif";